import { createStandardAction } from 'typesafe-actions';

export const cancelSpawnTasks = createStandardAction(
  'root/CANCEL_SPAWN_TASKS'
)();
